import type { NotificationGetNotifications200NotificationsItemBasicInfo } from './notificationGetNotifications200NotificationsItemBasicInfo';
import type { NotificationGetNotifications200NotificationsItemData } from './notificationGetNotifications200NotificationsItemData';
import type { NotificationGetNotifications200NotificationsItemSource } from './notificationGetNotifications200NotificationsItemSource';
import type { NotificationGetNotifications200NotificationsItemStatus } from './notificationGetNotifications200NotificationsItemStatus';
import type { NotificationGetNotifications200NotificationsItemTarget } from './notificationGetNotifications200NotificationsItemTarget';

/**
 * 알림 응답 데이터
 */
export type NotificationGetNotifications200NotificationsItem = {
  basicInfo?: NotificationGetNotifications200NotificationsItemBasicInfo;
  /** 알림 추가 데이터 (유형에 따라 다름) */
  data?: NotificationGetNotifications200NotificationsItemData;
  /** 알림 소스 정보 */
  source?: NotificationGetNotifications200NotificationsItemSource;
  /** 알림 상태 정보 */
  status?: NotificationGetNotifications200NotificationsItemStatus;
  /** 알림 대상 정보 */
  target?: NotificationGetNotifications200NotificationsItemTarget;
};
